import React from 'react'

import { useSelector } from 'react-redux'

import PricePanelAmount from '@components/UI/PricePanel/Amount'
import { IApplicationState } from '@store'
import {
  selectShareableContentLibraryAmount,
  selectShareableContentLibraryCurrency,
  selectShareableContentLibraryTax,
} from '@store/mediaObjects'

interface IProps {
  mediaObjectId: number
}

const ShareableContentLibraryFullPricePanelAmount: React.FC<IProps> = ({ mediaObjectId }) => {
  const price = useSelector((state: IApplicationState) =>
    selectShareableContentLibraryAmount(state, mediaObjectId),
  )
  const currency = useSelector((state: IApplicationState) =>
    selectShareableContentLibraryCurrency(state, mediaObjectId),
  )
  const taxDisplayName = useSelector((state: IApplicationState) =>
    selectShareableContentLibraryTax(state, mediaObjectId),
  )

  return (
    <PricePanelAmount price={price} currency={currency} taxDisplayName={taxDisplayName} showFrom />
  )
}

export { ShareableContentLibraryFullPricePanelAmount }
export default ShareableContentLibraryFullPricePanelAmount
